import React from 'react';
interface StitchLineProps {
  className?: string;
  tone?: 'coral' | 'sage';
}

/** A single running-stitch rule, used sparingly as a section detail. */
export function StitchLine({
  className = 'w-24',
  tone = 'coral'
}: StitchLineProps) {
  return <svg viewBox="0 0 120 4" preserveAspectRatio="none" className={`h-1 ${className}`} aria-hidden data-id="element-299" data-mp="1o01f5sgaqk2w">
      <line x1="2" y1="2" x2="118" y2="2" stroke={tone === 'coral' ? '#EF6488' : '#8B967D'} strokeWidth="2" strokeLinecap="round" strokeDasharray="7 6" vectorEffect="non-scaling-stroke" data-id="element-300" data-mp="1rzsa88cuvmd8" />
    </svg>;
}